/**
 * Sorts keys according to a provided display order. Keys present in `order`
 * are sorted by their index; keys not in `order` are pushed to the end while
 * maintaining their original relative order.
 *
 * @param keys - Array of keys to sort
 * @param order - Reference order the keys should follow
 * @returns Sorted copy of `keys`
 */
export default function sortByDisplayOrder(
  keys: string[],
  order: string[]
): string[] {
  return [...keys].sort((a, b) => {
    const indexA = order.indexOf(a);
    const indexB = order.indexOf(b);

    // Both keys are in the display order
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    // Only a is in the display order (comes first)
    if (indexA !== -1) {
      return -1;
    }

    // Only b is in the display order (comes first)
    if (indexB !== -1) {
      return 1;
    }

    // Neither is in the display order (maintain original relative order)
    return 0;
  });
}
